export default function formatString(str: string) {
	if (!str) {
		return '';
	}

	return str
		.trim()
		.toLowerCase()
		.replaceAll(/ *\([^)]*\) */g, '')
		.replaceAll(/[\s.,']/g, '')
		.replaceAll(' ', '-');
}

export function firstLetterUppercase(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatCategoryAbout(category: string[]): string {
	return category.map((el) => firstLetterUppercase(el)).join(' • ');
}
